import React from "react";
import "./classCard.css";
//import { f } from "../../../utils/formatTime";
import { Link } from "react-router-dom";
import { fDate } from "../../utils2/formatTime";

  function ClassCard ({ className, slotsLeft, moduleName, startDate, startTime, endDate, endTime, trainerName, deliveryMode, classCapacity, classId, path}) {
  return (
    <div className="group">
      <div className="overlap">
        <img className="icon-users" alt="Icon users" src="/ClassCardicons/Tranier.svg" />
        <Link to={`${path}/${classId}`}>
        <div className="group-wrapper">
          <div className="div">
           {/*} <img className="icon-arrow-left" alt="Icon arrow left" src="icon-arrow-left.png" /> */}
            <div className="text-wrapper">View class</div>
            
          </div>
        </div>
        </Link>
        
        <img className="icon-chalkboard" alt="Icon chalkboard" src="/ClassCardicons/Tranier.svg" />
        <div className="overlap-group">
          <img className="image" alt="Image" src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRz5j-xPvyWQofMQzCd0GosKM0XOxoLzdnQzY4S6wulDM5sGOY1Zmcy9rux9PoX9kYEgFM&usqp=CAU" />
        </div>
        <div className="study-abroad-GMAT">
         {className}
        </div>
        <p className="p">{fDate(startDate)} - {fDate(endDate)}</p>
        <div className="text-wrapper-2">Reading,Writing</div>
        <img className="vector" alt="Vector" src="/ClassCardicons/Clock.svg" />
        <div className="text-wrapper-3">{trainerName}</div>
        <div className="text-wrapper-4">{deliveryMode}</div>
        <div className="text-wrapper-5">{classCapacity} Students</div>
        <div className="text-wrapper-6">Class Trainer</div>
        <div className="text-wrapper-7">Delivery Mode</div>
        <div className="text-wrapper-8">Class Capacity</div>
        <img className="img" alt="Vector" src="vector-21.svg" />
        <img className="vector-2" alt="Vector" src="/ClassCardicons/Delivery Mode.svg" />
        <div className="overlap-group-wrapper">
          <div className="div-wrapper">
            <div className="text-wrapper-9">{slotsLeft} seats left</div>
          </div>
        </div>
        <img className="icon-alternate" alt="Icon alternate" src="/ClassCardicons/headphone.svg" />
      </div>
    </div>
  );
};

export default ClassCard
